import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "~/components/ui/dialog";

export type RecurrenceEditMode = 'this' | 'all' | 'thisAndFollowing';

interface RecurrenceEditModeDialogProps {
    open: boolean;
    isDelete?: boolean;
    onSelect: (mode: RecurrenceEditMode) => void;
    onCancel: () => void;
    occurrenceLabel?: string;    // "Dienstag, 07.07.2026"
    occurrenceDate?: string;     // "07.07.2026"
    seriesStartDate?: string;    // "07.07.2026"
    seriesEndDate?: string;      // "31.12.2026"
}

export function RecurrenceEditModeDialog({ open, isDelete, onSelect, onCancel, occurrenceLabel, occurrenceDate, seriesStartDate, seriesEndDate }: RecurrenceEditModeDialogProps) {
    const actionWord = isDelete ? 'löschen' : 'bearbeiten';
    const redLine = 'text-sm font-semibold text-red-600 dark:text-red-400 mt-1';

    return (
        <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onCancel(); }}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle>Wiederkehrendes Event {actionWord}</DialogTitle>
                    <DialogDescription>
                        Wie soll diese Änderung angewendet werden?
                    </DialogDescription>
                </DialogHeader>
                <div className="flex flex-col gap-2 py-4">
                    <Button
                        variant="outline"
                        className="justify-start h-auto py-3 px-4"
                        onClick={() => onSelect('this')}
                    >
                        <div className="text-left">
                            <div className="font-medium">Nur dieses Event</div>
                            <div className="text-xs text-muted-foreground">
                                Alle anderen Events der Serie bleiben unverändert.
                            </div>
                            {occurrenceLabel && (
                                <div className={redLine}>{occurrenceLabel}</div>
                            )}
                        </div>
                    </Button>
                    <Button
                        variant="outline"
                        className="justify-start h-auto py-3 px-4"
                        onClick={() => onSelect('thisAndFollowing')}
                    >
                        <div className="text-left">
                            <div className="font-medium">Dieses und alle folgenden Events</div>
                            <div className="text-xs text-muted-foreground">
                                Vergangene Events bleiben unverändert, ab diesem Event wird die Änderung übernommen.
                            </div>
                            {occurrenceDate && (
                                <div className={redLine}>Alle ab {occurrenceDate}</div>
                            )}
                        </div>
                    </Button>
                    <Button
                        variant="outline"
                        className="justify-start h-auto py-3 px-4"
                        onClick={() => onSelect('all')}
                    >
                        <div className="text-left">
                            <div className="font-medium">Alle Events der Serie</div>
                            <div className="text-xs text-muted-foreground">
                                Die Änderung gilt für alle vergangenen und zukünftigen Events.
                            </div>
                            {seriesStartDate && seriesEndDate && (
                                <div className={redLine}>Alle Events von {seriesStartDate} bis {seriesEndDate}</div>
                            )}
                        </div>
                    </Button>
                </div>
                <DialogFooter>
                    <Button variant="ghost" onClick={onCancel}>
                        Abbrechen
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
